module.exports = __webpack_public_path__ + "static/Genes2-f002a07b6c2ceafcbf085633c9075061.png";